<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">New Vessel</p>
    </header>
    <section class="modal-card-body">
      <form @submit="submit">
        <b-field label="" horizontal>
          <b-radio v-model="ownership_type"
            v-for="t in ['private', 'charter'].filter(
              o => (!(userType ==='charterer') || o !== 'private'))"
            :native-value="t" type="is-black" :key="t">{{t}}</b-radio>
        </b-field>
        <b-field label="Type" horizontal>
          <b-radio v-model="type" v-for="t in ['Sailing boat', 'Speed boat']"
            :native-value="t" type="is-black" :key="t">{{t}}</b-radio>
        </b-field>

        <b-field label="" horizontal v-if="!!type">
          <b-radio v-model="sub_type" v-for="t in subTypes"
            :native-value="t" type="is-black" :key="t">{{t}}</b-radio>
        </b-field>

        <b-field label="Size (ft)" horizontal>
          <b-input type="number" v-model="size_ft"/>
        </b-field>
        <b-field horizontal>
          <button class="is-primary button" type="submit">Submit</button>
        </b-field>
      </form>

    </section>

  </div>
</template>

<script>

export default {
  props: {
    userType: String,
  },
  data() {
    return {
      ownership_type: null,
      type: null,
      sub_type: null,
      size_ft: null,
    };
  },
  computed: {
    subTypes() {
      const types = ['Catamaran', 'Monohull'];
      if (this.type === 'Sailing boat') return types;
      return types.concat(['RIB']);
    },
  },
  methods: {
    submit(e) {
      e.preventDefault();
      const vessel = {
        type: this.type,
        ownership_type: this.ownership_type,
        sub_type: this.sub_type,
        size_ft: this.size_ft,
      };
      if (Object.values(vessel).some(v => !v)) {
        this.$toast.open({
          message: 'Please fill all the options',
          type: 'is-danger',
        });
        return;
      }
      this.$emit('vesselSaved', vessel);
      this.$parent.close();
    },
  },

};
</script>

<style lang="scss" scoped>
.rating-container {
  max-width: 400px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
